import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import withConfig from 'with-config';
import styled, {keyframes} from 'styled-components';
import oh from 'output-helpers';
import SSO from 'sso-helper';

import ForgotPasswordForm from '../components/ForgotPasswordForm';
import FormCard from '../components/FormCard';
import backgroundImage from '../img/background2.svg';

const background_fade = keyframes`
    0% {
        filter: hue-rotate(20deg);
    }
    100% {
        filter: none;
    }
`;

const Container = styled.div`
  animation: ${background_fade} 0.9s linear;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${backgroundImage});
  background-position: center 0;
  background-repeat: no-repeat;
  .success_box {
    background-color: #0a994d;
    background-image: linear-gradient(90deg, #006835, #62c05e);
    padding: 40px 42px;
    color: #fff;
    text-align: center;
    font-weight: 600;
    .label {
      font-size: 20px;
      line-height: 22px;
      margin-bottom: 16px;
    }
    a {
      font-size: 16px;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
  }
`;

const ForgotPassword = () => {
  let [processing, setProcessing] = useState(false);
  let [error_message, setErrorMessage] = useState('');
  let [done, setDone] = useState(false);

  useEffect(() => {
    const config = withConfig.getCurrentConfig();
    if (!window.sso) {
      window.sso = new SSO('dashboard', {
        token_provider_uri: config.api.sso.api_uri,
      });
    }
  }, []);

  return (
    <Container>
      <FormCard
        title={oh.translate('forgot_password')}
        subtitle="Forgot password subtitle"
      >
        {done ? (
          <div className="success_box">
            <p className="label">{oh.translate('password_reset_requested')}</p>
            <Link to="/">{oh.translate('return_to_login')}</Link>
          </div>
        ) : (
          <ForgotPasswordForm
            disabled={processing}
            error_message={error_message}
            onCloseErrorMessage={() => setErrorMessage('')}
            onSubmit={({username}) => {
              if (username.length < 1) {
                setErrorMessage(oh.translate('enter_your_username'));
                return;
              }
              setProcessing(true);
              window.sso
                .requestPasswordReset(username)
                .then(() => {
                  setDone(true);
                })
                .catch((err: any) => {
                  if (err.response && err.response.status === 404) {
                    setErrorMessage(oh.translate('error_check_spelling'));
                  } else {
                    setErrorMessage(oh.translate('error_general'));
                  }
                })
                .finally(() => {
                  setProcessing(false);
                });
            }}
          />
        )}
      </FormCard>
    </Container>
  );
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/views/ForgotPassword.tsx